import {
  RECEIVE_SHIPMENT_DATA,
  NO_RESULTS_SHIPMENT_DATA,
  RESET_NO_RESULTS_SHIPMENT_DATA,
  RECEIVE_NOT_FOUND_SHIPMENT_ID,
  REQUESTED_SHIPMENT_DATA, ERROR_RETRIEVING_SHIPMENT_DATA,
  REQUEST_SHIPMENT_DATA
} from "../actions/shipmentDataActions";
import {
  REQUEST_SHIPMENT_DATA_BY_ACCOUNT_NUMBER,
  RECEIVE_SHIPMENT_DATA_BY_ACCOUNT_NUMBER,
  SHIPMENT_BY_ACCOUNT_NUMBER_SERVICE_ERROR
} from "../actions/shipmentDataByAccountNumberActions";

const initialState = {
  items: [],
  noResults: false,
  notFoundTrackingIds: [],
  requestedShipmentData: false,
  isFetching: false
};

export default function (state = initialState, action) {

  switch (action.type) {
    case REQUEST_SHIPMENT_DATA_BY_ACCOUNT_NUMBER:
      return {
          ...state,
          isFetching: true
      };
    case REQUEST_SHIPMENT_DATA:
      return {
        ...state,
        isFetching: true
      };
    case RECEIVE_SHIPMENT_DATA:
      return {
        ...state,
        items: action.payload,
        isFetching: false
      };
    case NO_RESULTS_SHIPMENT_DATA:
      return {
        ...state,
        noResults: true,
        isFetching: false
      };
    case RESET_NO_RESULTS_SHIPMENT_DATA:
      return {
        ...state,
        noResults: false,
        isFetching: false
      };
    case RECEIVE_NOT_FOUND_SHIPMENT_ID:
      return {
        ...state,
        notFoundTrackingIds: action.payload,
        isFetching: false
      };
    case REQUESTED_SHIPMENT_DATA:
      return {
        ...state,
        requestedShipmentData: true,
        isFetching: false
      };
    case RECEIVE_SHIPMENT_DATA_BY_ACCOUNT_NUMBER:
      return {
        ...state,
        items: action.payload,
        isFetching: false
      };
    case ERROR_RETRIEVING_SHIPMENT_DATA:
      return {
        ...initialState,
        error: action.payload,
        isFetching: false
      };
    case SHIPMENT_BY_ACCOUNT_NUMBER_SERVICE_ERROR:
      return {
        ...state,
        isFetching: false
      };
    default:
      return state;
  }
}


// WEBPACK FOOTER //
// ./src/reducers/shipmentReducer.js